var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    transform: "matrix(-1 0 0 1 39 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66448 12.818C4.2975 11.7762 4.84457 10.6341 5.88639 10.2672L16.1138 6.66458C17.1556 6.29759 18.2976 6.84466 18.6646 7.88649L25.7376 27.9658C26.1045 29.0076 25.5575 30.1497 24.5157 30.5167L14.2883 34.1193C13.2465 34.4863 12.1044 33.9392 11.7374 32.8974L4.66448 12.818Z",
    fill: "var(--color-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6121 8.07937L6.38475 11.682C6.12429 11.7737 5.98753 12.0592 6.07927 12.3197L13.1522 32.399C13.2439 32.6595 13.5295 32.7962 13.7899 32.7045L24.0173 29.1019C24.2777 29.0101 24.4145 28.7246 24.3228 28.4642L17.2498 8.38485C17.1581 8.12439 16.8726 7.98762 16.6121 8.07937ZM5.88639 10.2672C4.84457 10.6341 4.2975 11.7762 4.66448 12.818L11.7374 32.8974C12.1044 33.9392 13.2465 34.4863 14.2883 34.1193L24.5157 30.5167C25.5575 30.1497 26.1045 29.0076 25.7376 27.9658L18.6646 7.88649C18.2976 6.84466 17.1556 6.29759 16.1138 6.66458L5.88639 10.2672Z",
    fill: "var(--color-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1627 9.76271C12.103 8.65975 12.9488 7.71728 14.0518 7.65764L24.8793 7.0722C25.9822 7.01257 26.9247 7.85835 26.9843 8.9613L28.1337 30.2189C28.1934 31.3218 27.3476 32.2643 26.2446 32.3239L15.4171 32.9094C14.3142 32.969 13.3717 32.1232 13.3121 31.0203L12.1627 9.76271Z",
    fill: "var(--color-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9603 8.57001L14.1328 9.15546C13.857 9.17036 13.6456 9.40598 13.6605 9.68172L14.8099 30.9393C14.8248 31.215 15.0604 31.4265 15.3361 31.4116L26.1637 30.8261C26.4394 30.8112 26.6508 30.5756 26.6359 30.2999L25.4865 9.04229C25.4716 8.76655 25.236 8.55511 24.9603 8.57001ZM14.0518 7.65764C12.9488 7.71728 12.103 8.65975 12.1627 9.76271L13.3121 31.0203C13.3717 32.1232 14.3142 32.969 15.4171 32.9094L26.2446 32.3239C27.3476 32.2643 28.1934 31.3218 28.1337 30.2189L26.9843 8.9613C26.9247 7.85835 25.9822 7.01257 24.8793 7.0722L14.0518 7.65764Z",
    fill: "var(--color-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9532 8.57134C20.198 7.49425 21.2696 6.81957 22.3467 7.06441L32.3842 9.34607C33.4613 9.59091 34.136 10.6625 33.8912 11.7396L29.1724 32.4987C28.9275 33.5758 27.8559 34.2505 26.7788 34.0056L16.7413 31.724C15.6642 31.4791 14.9895 30.4075 15.2344 29.3304L19.9532 8.57134Z",
    fill: "var(--color-1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0518 10.8088L22.0142 8.5271C21.745 8.46589 21.4771 8.63456 21.4159 8.90383L16.697 29.6629C16.6358 29.9322 16.8045 30.2001 17.0738 30.2613L27.1113 32.5429C27.3806 32.6042 27.6485 32.4355 27.7097 32.1662L32.4285 11.4071C32.4897 11.1379 32.321 10.87 32.0518 10.8088ZM22.3467 7.06441C21.2696 6.81957 20.198 7.49425 19.9532 8.57134L15.2344 29.3304C14.9895 30.4075 15.6642 31.4791 16.7413 31.724L26.7788 34.0056C27.8559 34.2505 28.9275 33.5758 29.1724 32.4987L33.8912 11.7396C34.136 10.6625 33.4613 9.59091 32.3842 9.34607L22.3467 7.06441Z",
    fill: "var(--color-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulk);
export default __webpack_public_path__ + "static/media/bulk.afee96c559bb9c9273c8e3e4ee6e125d.svg";
export { ForwardRef as ReactComponent };